/**
 * document-validation.js — Dislicores
 *
 * Reglas compartidas de tipo y numero de documento. Vive en un solo archivo
 * para que el modal del gate (age-cedula-gate.js) y el formulario de la cuenta
 * (customer-dashboard-custom.liquid) no se desincronicen.
 *
 * Los codigos de una letra son los que se guardan en el metacampo
 * vtex.document_type y los que viajan al backend en `document_type`.
 *
 * Antes solo existia cedula de ciudadania y se exigian 10 digitos exactos. Con
 * pasaporte y documentos del exterior eso ya no aplica: el largo varia y puede
 * haber letras, asi que la regla depende del tipo elegido.
 */
(function () {
  'use strict';

  var TYPES = [
    { code: 'C', label: 'CC Cédula de ciudadanía' },
    { code: 'E', label: 'Nit del exterior' },
    { code: 'F', label: 'Código fiscal del exterior' },
    { code: 'N', label: 'NIT Número de identificación tributaria' },
    { code: 'O', label: 'Otros' },
    { code: 'P', label: 'Pasaporte' },
    { code: 'T', label: 'TI Tarjeta de identidad' },
    { code: 'X', label: 'Cédula de Extranjería' }
  ];

  // numeric: solo digitos (documentos colombianos).
  // alnum: letras y digitos (pasaportes y documentos del exterior).
  var RULES = {
    C: { kind: 'numeric', min: 6, max: 10, help: 'Entre 6 y 10 dígitos, sin puntos ni guiones.' },
    T: { kind: 'numeric', min: 6, max: 11, help: 'Entre 6 y 11 dígitos, sin puntos ni guiones.' },
    N: { kind: 'numeric', min: 9, max: 10, help: 'Entre 9 y 10 dígitos, sin el dígito de verificación.' },
    P: { kind: 'alnum', min: 5, max: 20, help: 'Entre 5 y 20 caracteres, letras y números.' },
    X: { kind: 'alnum', min: 5, max: 20, help: 'Entre 5 y 20 caracteres, letras y números.' },
    E: { kind: 'alnum', min: 5, max: 20, help: 'Entre 5 y 20 caracteres, letras y números.' },
    F: { kind: 'alnum', min: 5, max: 20, help: 'Entre 5 y 20 caracteres, letras y números.' },
    O: { kind: 'alnum', min: 5, max: 20, help: 'Entre 5 y 20 caracteres, letras y números.' }
  };

  var DEFAULT_RULE = { kind: 'alnum', min: 5, max: 20, help: 'Sin puntos, espacios ni guiones.' };

  function getRule(type) {
    return Object.prototype.hasOwnProperty.call(RULES, type) ? RULES[type] : DEFAULT_RULE;
  }

  function isValidType(type) {
    return TYPES.some(function (item) { return item.code === type; });
  }

  // Se normaliza segun el tipo: los numericos pierden todo lo que no sea
  // digito; los alfanumericos conservan letras y pasan a mayusculas.
  function clean(value, type) {
    var rule = getRule(type);
    var raw = String(value == null ? '' : value);

    if (rule.kind === 'numeric') {
      return raw.replace(/\D/g, '').slice(0, rule.max);
    }

    return raw.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, rule.max);
  }

  function validateType(type) {
    if (!type) {
      return { valid: false, value: '', message: 'Selecciona el tipo de documento.' };
    }
    if (!isValidType(type)) {
      return { valid: false, value: '', message: 'Selecciona un tipo de documento válido.' };
    }
    return { valid: true, value: type, message: '' };
  }

  function validateNumber(value, type) {
    var rule = getRule(type);
    var cleanValue = clean(value, type);

    if (!cleanValue) {
      return { valid: false, value: cleanValue, message: 'Ingresa tu número de documento.' };
    }

    if (cleanValue.length < rule.min || cleanValue.length > rule.max) {
      var unidad = rule.kind === 'numeric' ? 'dígitos' : 'caracteres';
      return {
        valid: false,
        value: cleanValue,
        message: 'El documento debe tener entre ' + rule.min + ' y ' + rule.max + ' ' + unidad + '.'
      };
    }

    if (rule.kind === 'numeric' && !/^\d+$/.test(cleanValue)) {
      return { valid: false, value: cleanValue, message: 'Este tipo de documento solo admite números.' };
    }

    // Un documento de un solo caracter repetido (1111111111) es siempre un
    // error de digitacion, sea del tipo que sea.
    if (/^(.)\1+$/.test(cleanValue)) {
      return {
        valid: false,
        value: cleanValue,
        message: 'Ingresa un documento válido, no una secuencia repetida.'
      };
    }

    return { valid: true, value: cleanValue, message: '' };
  }

  window.DislicoresDocument = {
    TYPES: TYPES,
    getRule: getRule,
    isValidType: isValidType,
    clean: clean,
    validateType: validateType,
    validateNumber: validateNumber
  };
})();
